import { useQuery, useQueryClient } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
const SETTINGS_URL = "/plugins/org.graylog.plugins.license/licenses/traffic-limit-violations/settings";
export const TRAFFIC_LIMIT_VIOLATION_CONFIG_QUERY_KEY = ["traffic-violation", "config"];
const fetchTrafficLimitViolationConfig = () => fetch("GET", qualifyUrl(SETTINGS_URL)).then((response) => response.email_recipients).catch((error) => {
  UserNotification.error(
    `Fetching Traffic violation limit configuration failed with status: ${error}`,
    "Could not load Traffic violation limit configuration"
  );
  return void 0;
});
export const updateTrafficLimitViolationConfig = (config) => {
  const url = qualifyUrl(SETTINGS_URL);
  return fetch("PUT", url, config).catch((error) => {
    UserNotification.error(
      `Saving Traffic violation limit configuration failed with status: ${error}`,
      "Could not save Traffic violation limit configuration"
    );
    throw error;
  });
};
const useTrafficLimitViolationConfig = () => {
  const queryClient = useQueryClient();
  const { data } = useQuery({
    queryKey: TRAFFIC_LIMIT_VIOLATION_CONFIG_QUERY_KEY,
    queryFn: fetchTrafficLimitViolationConfig,
    retry: false
  });
  const invalidate = () => queryClient.invalidateQueries({ queryKey: TRAFFIC_LIMIT_VIOLATION_CONFIG_QUERY_KEY });
  return {
    emailRecipients: data,
    invalidateTrafficLimitViolationConfig: invalidate
  };
};
export default useTrafficLimitViolationConfig;
